import { render } from "./ModalComprobanteOi.vue?vue&type=template&id=0ba82a0c&scoped=true"
import script from "./ModalComprobanteOi.vue?vue&type=script&lang=js"
export * from "./ModalComprobanteOi.vue?vue&type=script&lang=js"

import "./ModalComprobanteOi.vue?vue&type=style&index=0&id=0ba82a0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba82a0c"]])

export default __exports__